import React, { memo, useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useSuggester } from "../../../../../core/suggest/useSuggester";
import { EditorCursorPopup } from "../../../../popup";
import { MemberSuggesterMenu } from "../MemberSuggesterMenu/MemberSuggesterMenu";
export const MemberSuggesterRaw = ({ view, suggesterCallbacksRegistry, mentionService, onPublicProfileOpen, }) => {
    const [suggester, setSuggester] = useState(null);
    const filteredMembers = useMemo(() => {
        const query = suggester === null || suggester === void 0 ? void 0 : suggester.queryText.partial;
        return mentionService.searchMembers(query);
    }, [mentionService, suggester]);
    const filteredTeams = useMemo(() => {
        const query = suggester === null || suggester === void 0 ? void 0 : suggester.queryText.partial;
        return mentionService.searchTeams(query);
    }, [mentionService, suggester]);
    const filteredItems = useMemo(() => [...filteredMembers, ...filteredTeams], [filteredMembers, filteredTeams]);
    const handleEnter = useCallback((index) => {
        suggester.command(filteredItems[index]);
    }, [filteredItems, suggester]);
    const menuRef = useRef();
    const { visible, activeIndex } = useSuggester({
        menuRef,
        suggesterCallbacksRegistry,
        commandsLength: filteredItems.length,
        onEnter: handleEnter,
        onParamsChange: useCallback((suggesterParams) => setSuggester(suggesterParams), []),
    });
    useEffect(() => {
        var _a;
        (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-item-index="${activeIndex}"]`).scrollIntoView({ block: "nearest" });
    }, [activeIndex]);
    if (!visible || !suggester) {
        return null;
    }
    return (React.createElement(EditorCursorPopup, { view: view, from: suggester.range.from, to: suggester.range.to, placement: "bottom-start", flipEnabled: true, preventOverFlowEnabled: false },
        React.createElement(MemberSuggesterMenu, { ref: menuRef, activeIndex: activeIndex, members: filteredMembers, teams: filteredTeams, onClick: handleEnter, onPublicProfileOpen: onPublicProfileOpen })));
};
export const MemberSuggester = memo(MemberSuggesterRaw);
